
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[_network]/streams/[_id]",
      function () {
        return require("private-next-pages/[_network]/streams/[_id].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[_network]/streams/[_id]"])
      });
    }
  